import React from 'react'
import { connect } from 'react-redux'
import Loader from '../../loaders'
import { strings } from '../../../localization/strings'
import TextField from '@material-ui/core/TextField/TextField'
import FormLabel from '@material-ui/core/FormLabel/FormLabel'
import Button from '@material-ui/core/Button/Button'
import { orderTypes } from '../../../server/shared'
import { getCountrySubdivisionsAction } from '../../../actions/appActions'
import {
    getShippingRates,
    dispatchToLocker,
    getDoorSizes,
} from '../../../helpers/restHelpers'
import { PhoneNumberFormat } from '../../../utils/formaters'
import Typography from '@material-ui/core/Typography/Typography'
import { Grid, IconButton } from '@material-ui/core'
import InfoIcon from '@material-ui/icons/Info'
import {
    getShowDispatchToLockerExplanationVersion,
    setShowDispatchToLockerExplanationVersion,
} from '../../../helpers/dbHelpers'
import LockerSelectorInMap from '../../components/lockerSelectorInMap'
import DoorSizeSelector from '../../components/doorSizeSelector'

const style = {
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
    },
    page: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 500,
        margin: 'auto',
        padding: '20px 10px',
    },
    field: { marginTop: 15, flexGrow: 1 },
    option: { marginTop: 15, marginLeft: 25 },
}

const formatReq = (string) => (
    <div>
        {string}
        <span style={{ color: 'red' }}> *</span>
    </div>
)
const reload = () => window.location.reload(true)

class Component extends React.Component {
    state = {
        loading: true,
        reference: new Date().getTime(),
        shippingMethodList: null,
        errors: {},
        dispatchToLocker: this.props.dispatchToLocker,
        alias: '',
        postalCode: '',
        warehouse: null,
        doorSizeList: [],
        doorSizeId: null,
    }

    componentDidMount() {
        this.loadProvinceList()
        this.loadDoorSizeList()
    }

    loadDoorSizeList = () => {
        getDoorSizes()
            .then((x) => this.setState({ doorSizeList: x }))
            .catch((x) => window.showDialog(x, reload))
    }

    loadProvinceList = () => {
        getCountrySubdivisionsAction(1)
            .then((x) =>
                x.length
                    ? this.setState({ provinceList: x, loading: false })
                    : window.showDialog({}, reload)
            )
            .catch((x) => window.showDialog(x, reload))
    }

    submitCreateValidate = () => {
        let errors = {}
        let { alias, postalCode } = this.state

        if (!alias) errors.alias = true
        if (!postalCode) errors.postalCode = true

        let { lockerId, doorSizeId } = this.state
        if (!lockerId) errors.shippingMethodId = true
        if (!doorSizeId) errors.shippingMethodId = true

        this.setState({ errors: errors })
        if (Object.keys(errors).length > 0) return false
        return true
    }

    submitCreate = () => {
        if (!this.submitCreateValidate()) return

        let { reference, alias, lockerId, doorSizeId } = this.state

        let mail = strings.dispatchToLockerMail
        let phoneNumber = ''
        let orderType = orderTypes.dispatch
        let shippingMethodId = 1

        let data = {
            orderType,
            reference,
            alias,
            mail,
            phoneNumber,
            shippingMethodId,
            lockerId,
            doorSizeId,
        }

        this.setState({ loading: true })

        dispatchToLocker(data)
            .then(() =>
                window.showDialog(
                    {
                        message:
                            strings.dispatchToLockerSuccessfulCreationMessage,
                        title: ' ',
                    },
                    reload
                )
            )
            .catch((x) => window.showDialog(x, reload))
    }

    calculate = (doorSizeId) => {
        const { postalCode } = this.state
        const ordeType = orderTypes.dispatch
        this.setState({ loading: true })
        getShippingRates(postalCode, ordeType, doorSizeId)
            .then((x) => {
                let optionMerge = []
                x.filter(
                    (y) => y.shippingMethodId === 1 || y.shippingMethodId === 3
                ).forEach((y) => (optionMerge = optionMerge.concat(y.options)))
                if (optionMerge.length > 0) {
                    this.setState({
                        shippingMethodList: [{ cost: 0, options: optionMerge }],
                        doorSizeId: doorSizeId,
                        lockerId: null,
                    })
                } else {
                    this.setState({ shippingMethodList: [] })
                }
            })
            .catch((x) => window.showDialog(x))
            .finally(() => this.setState({ loading: false }))
    }

    renderStandardMethod = (lockerList) => {
        if (!this.state.doorSizeId) {
            return (
                <DoorSizeSelector
                    list={this.state.doorSizeList}
                    handleNext={this.calculate}
                />
            )
        }
        const doorSizeName = this.state.doorSizeList.find(
            (x) => x.id === this.state.doorSizeId
        ).name
        return (
            <LockerSelectorInMap
                list={lockerList}
                idSelected={this.state.lockerId}
                handleChange={(x) => this.setState({ lockerId: x })}
                doorSizeName={doorSizeName}
                handleDoorSizeClick={() => this.calculate()}
            />
        )
    }

    getLastDispatchToLockerDescriptionVersion = () => {
        let versions = Object.keys(strings.dispatchToLockerDescriptions)
            .map((x) => Number.parseInt(x))
            .reverse()
        return versions[0]
    }

    getLastDispatchToLockerDescription = () => {
        let version = this.getLastDispatchToLockerDescriptionVersion()
        return strings.dispatchToLockerDescriptions[version]
    }

    showExplanationDialogs = () => {
        let dispatchToLockerExplanationVersion =
            getShowDispatchToLockerExplanationVersion()
        let lastDispatchToLockerVersion =
            this.getLastDispatchToLockerDescriptionVersion()

        if (
            dispatchToLockerExplanationVersion == null ||
            lastDispatchToLockerVersion > dispatchToLockerExplanationVersion
        ) {
            setTimeout(() => {
                window.showDialog(
                    {
                        title: ' ',
                        message: this.getLastDispatchToLockerDescription(),
                    },
                    () =>
                        setShowDispatchToLockerExplanationVersion(
                            lastDispatchToLockerVersion
                        )
                )
            }, 0)
        }
    }

    getPostalCodePlaceholder = () => {
        try {
            let cp = this.props.appStore.warehouseInfo.address.postalCode
            if (!cp) new Error()
            return 'Ej. ' + cp
        } catch (e) {
            return strings.postalCodePlaceholder
        }
    }

    render() {
        let { errors, shippingMethodList, alias, postalCode, lockerId } =
            this.state

        if (this.state.loading) return <Loader />

        this.showExplanationDialogs()

        return (
            <div style={style.page}>
                <Grid item style={{ textAlign: 'center' }} xs={12}>
                    <Typography variant={'h6'}>
                        {strings.dispatchToLockerHeader}
                        <IconButton
                            onClick={() =>
                                window.showDialog({
                                    title: ' ',
                                    message:
                                        this.getLastDispatchToLockerDescription(),
                                })
                            }
                        >
                            <InfoIcon fontSize="small" />
                        </IconButton>
                    </Typography>
                </Grid>

                <TextField
                    label={formatReq(strings.orderNewAlias)}
                    placeholder={strings.dispatchToLockerAliasPlaceholder}
                    value={alias}
                    onChange={(x) =>
                        this.setState({
                            alias: x.target.value,
                            errors: { ...errors, alias: false },
                        })
                    }
                    error={errors.alias}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ maxLength: 19 }}
                    style={style.field}
                />

                <div style={style.row}>
                    <TextField
                        label={formatReq(strings.postalCode)}
                        value={postalCode}
                        placeholder={this.getPostalCodePlaceholder()}
                        onChange={(x) =>
                            this.setState({
                                postalCode: x.target.value,
                                shippingMethodList: null,
                                errors: { ...errors, postalCode: false },
                            })
                        }
                        error={errors.postalCode}
                        InputLabelProps={{ shrink: true }}
                        style={style.field}
                        InputProps={{ inputComponent: PhoneNumberFormat }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.calculate()}
                        disabled={!postalCode}
                    >
                        {strings.dispatchToLockerSearchButton}
                    </Button>
                </div>

                <div style={style.field} />
                <div style={style.field} />

                {!shippingMethodList ? null : !shippingMethodList.length ? (
                    <Typography variant="h6" color="secondary">
                        {strings.dispatchToLockerMethodsEmpty}
                    </Typography>
                ) : (
                    <>
                        <FormLabel component="legend">
                            {strings.dispatchToLockerShippingMethodsTitle}
                        </FormLabel>
                        {shippingMethodList.map((method, index) => (
                            <div key={index}>
                                {this.renderStandardMethod(
                                    method.options,
                                    null
                                )}
                            </div>
                        ))}
                    </>
                )}

                <Button
                    style={{ margin: 'auto', marginTop: 30 }}
                    variant="contained"
                    color="primary"
                    onClick={this.submitCreate}
                    disabled={!lockerId}
                >
                    {strings.dispatchToLockerCreateButton}
                </Button>
            </div>
        )
    }
}

const mapDispatchToProps = {}
const mapStateToProps = (store) => ({ appStore: store.app })
export default connect(mapStateToProps, mapDispatchToProps)(Component)
